import { useRouteError } from 'react-router-dom';

import { AppContentFallback } from '../Statuses/AppContentFallback';

export const RouteError = () => {
	const error = useRouteError();

	return <AppContentFallback error={error} />;
};
